export default __webpack_public_path__ + "static/media/gift-card.edef8576.svg";